module.exports = __webpack_public_path__ + "img/vol04_character_name_sp.43e8efeb.png";